import { render, staticRenderFns } from "./AuthRole.vue?vue&type=template&id=49951b62"
import script from "./AuthRole.vue?vue&type=script&lang=js"
export * from "./AuthRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports